import React from "react";
import RedeemFailed from "../../Assets/imgNewUI/RedeemFailed.png";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import { onPostDealCodeReset } from "../../Store/Slices/dealCouponCodeSlice";
import { useDispatch } from "react-redux";

const RedeemFailedModal = ({ navigate, reDirect }) => {
  const translation = getTranslation();
  const disptach = useDispatch();
  const handleButtonClick = (coupon) => {
    disptach(onPostDealCodeReset());
    navigate(coupon ? "/" : -1);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white shadow-lg warn-card py-6 text-center px-4">
        <div className="flex justify-center mb-2">
          <img src={RedeemFailed} alt="warmStar" />
        </div>

        <span className="warn-span mx-4">
          {translation?.claimIssue}
        </span>

        <button className="ok-button px-4 mt-4" onClick={() => handleButtonClick(reDirect)}>
          {translation?.okLabel}
        </button>
      </div>
    </div>
  );
};

export default RedeemFailedModal;
